import { type Params } from './useRadarForegroundTracking.types';

/**
 * Native-only hook.
 */
export function useRadarForegroundTracking(_params: Params) {}
